import { Controller } from "@hotwired/stimulus"

// data-controller="vehicle_menu"
export default class extends Controller {
  static targets = ["popover"]

  toggle(e) {
    e?.preventDefault()
    if (!this.hasPopoverTarget) return
    const el = this.popoverTarget
    const isHidden = el.hasAttribute("hidden")
    if (isHidden) el.removeAttribute("hidden"); else el.setAttribute("hidden", "")
  }

  triggerKey(e) {
    if (e.key === "Enter" || e.key === " ") this.toggle(e)
    if (e.key === "Escape") this._hide()
  }

  select(e) {
    const id = e.currentTarget.getAttribute("data-id")
    // Ping backend to memorize selection then redirect to vehicle page
    fetch(`/session/current_car`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this._csrf() },
      body: JSON.stringify({ id })
    }).then(() => {
      // Rediriger vers la page du véhicule
      window.location.href = `/vehicles/${id}`
    }).catch(() => {
      // Fallback: rediriger quand même
      window.location.href = `/vehicles/${id}`
    })
    this._hide()
  }

  _hide() {
    if (this.hasPopoverTarget) this.popoverTarget.setAttribute("hidden", "")
  }

  _csrf() { return document.querySelector('meta[name="csrf-token"]').content }
}
